export default __webpack_public_path__ + "static/media/slide6.c458ada9.png";